import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {PhonenumberEntry} from '../../models/phonenumber-entry';
import {PhoneNumberSelectorComponent} from '../phone-number-selector/phone-number-selector.component';
import {GtPhoneNumberUtil} from '../utils/gt-phone-number.util';
import {GtDirectoryService} from '@app/services/gt-directory.service';
import {ContactModel} from '../../models/contact.model';

@Component({
  selector: 'gt-phonenumber-adder',
  templateUrl: './phone-number-adder.component.html',
  styleUrls: ['./phone-number-adder.component.scss']
})
export class PhoneNumberAdderComponent implements OnInit {
  @Output() phonenumberChange: EventEmitter<PhonenumberEntry[]> = new EventEmitter();
  @Output() removeEntryChange: EventEmitter<PhonenumberEntry> = new EventEmitter();
  @Output() addEntryChange: EventEmitter<PhonenumberEntry> = new EventEmitter();
  @Input() entries: PhonenumberEntry[] = [];
  @Input() maxEntries = 50;
  @Input() orgId: string;
  @Input() searchMainNumbers = false;
  @Input() searchEndUsers = true;
  @Input() searchContacts = true;
  @Input() allowOtherNumber = true;
  @Input() canEdit = true;
  @Input() clearAfterAdd = false;
  selectedPhoneNumber: PhonenumberEntry = null;
  @ViewChild(PhoneNumberSelectorComponent) phoneNumSelectorComponent: PhoneNumberSelectorComponent;

  contacts: ContactModel[];

  constructor(private directoryService: GtDirectoryService) {}

  ngOnInit() {
    this.directoryService.getContacts(this.orgId, false).subscribe(x => (this.contacts = x));
  }

  emittedArray(event?: string): void {
    if (this.selectedPhoneNumber && this.selectedPhoneNumber.fullNumber) {
      this.addNumberToArray(); // if this selectedPhoneNumber has a value, we don't want to use the raw emitted value
    } else if (event) {
      const numbers = event.replace(/ /g, '').split(',');
      if (numbers) {
        numbers
          .filter(num => GtPhoneNumberUtil.isValidNumber(num) || this.contacts.some(c => c.phoneNumber === num))
          .forEach(num => {
            this.selectedPhoneNumber = new PhonenumberEntry(num);
            this.addNumberToArray();
          });

        this.phoneNumSelectorComponent.updateInputControlValue(
          numbers.filter(num => !GtPhoneNumberUtil.isValidNumber(num) && !this.contacts.some(c => c.phoneNumber === num)).toString()
        );
        this.selectedPhoneNumber = null;
      } else {
        this.selectedPhoneNumber = new PhonenumberEntry(event);
        this.addNumberToArray();
      }
    } else {
      this.addNumberToArray();
    }
  }

  okClicked() {
    if (this.selectedPhoneNumber && this.selectedPhoneNumber.fullNumber) {
      this.addNumberToArray();
    } else {
      this.emittedArray(this.phoneNumSelectorComponent.getRawString());
    }
  }

  private addNumberToArray() {
    if (
      this.selectedPhoneNumber &&
      this.selectedPhoneNumber.fullNumber &&
      this.selectedPhoneNumber.fullNumber.length &&
      !this.alreadyAdded(this.selectedPhoneNumber)
    ) {
      this.entries.push(this.selectedPhoneNumber);
      if (this.entries.length > this.maxEntries) {
        this.entries.shift(); // remove first entry to keep list size at maxEntries
      }
      this.addEntryChange.emit(this.selectedPhoneNumber);
      this.phonenumberChange.emit(this.entries);
      this.phoneNumSelectorComponent.updateInputControlValue('');
    }
  }

  removeEntry(entry: PhonenumberEntry): void {
    this.entries.splice(this.entries.indexOf(entry), 1);
    this.phonenumberChange.emit(this.entries);
    this.removeEntryChange.emit(entry);
  }

  private alreadyAdded(entry: PhonenumberEntry): boolean {
    return (
      this.entries.find(e => {
        return e.getE164Number() === entry.getE164Number();
      }) !== undefined
    );
  }
}
